import { router, useLocalSearchParams } from "expo-router"

import { BrandForm } from "@src/components/brand-form"
import { Header } from "@src/components/Header"
import { ar } from "@src/i18n"
import { trpc } from "@src/utils/trpc"
import { ActivityIndicator } from "react-native"

export default function EditBrand() {
  const params = useLocalSearchParams<{ id: string }>()
  const id = Number.parseInt(params.id, 10) as number
  const brands = trpc.brands.list.useQuery()

  if (brands.isLoading) {
    return (
      <>
        <Header title={ar.editBrand} />
        <ActivityIndicator className="py-8" />
      </>
    )
  }

  return (
    <>
      <Header title={ar.editBrand} />
      <BrandForm
        id={id}
        onClose={() => {
          if (router.canGoBack()) {
            router.back()
          } else {
            router.replace("/dashboard/brand")
          }
        }}
      />
    </>
  )
}
